<template>
    <form @submit.prevent="submit">
        <div class="flex justify-between items-center">
            <h3>Vul onderstaand formulier in en wij nemen zo spoedig mogelijk contact met je op!</h3>
        </div>

        <div class="mt-4 grid gap-y-4 gap-x-4 grid-cols-6">
            <!-- Name -->
            <div class="col-span-3">
                <label for="name" class="block text-sm h-5 font-semibold text-gray-700">Voornaam</label>
                <div class="mt-1">
                    <input
                        type="text"
                        name="first_name"
                        id="first_name"
                        autocomplete="given-name"
                        placeholder="Voornaam"
                        v-model="form.first_name"
                        class="text-input"
                        :class="!form.first_name && form.errors.first_name ? 'text-input-failed' : ''"
                    />
                    <transition name="pop">
                        <div class="error-text" v-if="!form.first_name && form.errors.first_name">
                            {{ form.errors.first_name }}
                        </div>
                    </transition>
                </div>
            </div>

            <div class="col-span-3">
                <label for="last_name" class="block text-sm h-5 font-semibold text-gray-700">Achternaam</label>
                <div class="mt-1">
                    <input
                        type="text"
                        name="last_name"
                        id="last_name"
                        autocomplete="family-name"
                        placeholder="Achternaam"
                        v-model="form.last_name"
                        class="text-input"
                        :class="!form.last_name && form.errors.last_name ? 'text-input-failed' : ''"
                    />
                    <transition name="pop">
                        <div class="error-text" v-if="!form.last_name && form.errors.last_name">
                            {{ form.errors.last_name }}
                        </div>
                    </transition>
                </div>
            </div>

            <!-- Phone -->
            <div class="col-span-6 md:col-span-4">
                <label for="email" class="block text-sm h-5 font-semibold text-gray-700"> E-mail </label>
                <div class="mt-1">
                    <input
                        id="email"
                        name="email"
                        type="email"
                        autocomplete="email"
                        v-model="form.email"
                        class="text-input"
                        placeholder="E-mail"
                        :class="!form.email && form.errors.email ? 'text-input-failed' : ''"
                    />
                    <transition name="pop">
                        <div class="error-text" v-if="!form.email && form.errors.email">
                            {{ form.errors.email }}
                        </div>
                    </transition>
                </div>
            </div>
            <div class="col-span-6 md:col-span-4">
                <label for="phone" class="block text-sm h-5 font-semibold text-gray-700">
                    Telefoonnummer <span class="text-gray-600 font-light">(optioneel)</span>
                </label>
                <div class="mt-1">
                    <input
                        type="tel"
                        name="phone"
                        id="phone"
                        autocomplete="tel"
                        placeholder="06 123456789"
                        v-model="form.phone"
                        class="text-input"
                    />
                </div>
            </div>
            <div class="col-span-6 md:col-span-4">
                <label for="comment" class="block text-sm h-5 font-semibold text-gray-700"> Motivatie </label>
                <div class="mt-1">
                    <textarea
                        class="textarea text-input"
                        placeholder="Motivatie"
                        v-model="form.comment"
                        rows="4"
                        cols="50"
                        :class="!form.comment && form.errors.comment ? 'text-input-failed' : ''"
                    ></textarea>
                    <transition name="pop">
                        <div class="error-text" v-if="!form.comment && form.errors.comment">
                            {{ form.errors.comment }}
                        </div>
                    </transition>
                </div>
            </div>

            <!-- Comment cylinders -->
            <div class="col-span-6">
                <!-- <h3>Cilinders</h3> -->
                <div class="w-full flex flex-wrap mb-6">
                    <form class="w-full">
                        <label class="block">
                            <label for="phone" class="block text-sm h-5 font-semibold text-gray-700 mb-4">
                                Upload CV / Motivatie <span class="text-gray-600 font-light">(optioneel)</span>
                            </label>
                            <input
                                type="file"
                                @input="form.file = $event.target.files[0]"
                                class="block w-full text-sm text-gray-800 file:mr-4 file:py-2 file:px-4 file:bg-white file:rounded-md file:border file:text-sm file:font-semibold hover:file:bg-gray-50"
                            />
                        </label>
                    </form>
                </div>
            </div>
        </div>
        <div class="w-full md:w-1/2">
            <button type="submit" :disabled="form.processing" class="button green w-full mt-6">
                <fa
                    :icon="['fad', 'spinner-third']"
                    class="text-white opacity-80 mr-2 fa-spin"
                    v-if="form.processing"
                />

                Versturen
            </button>
        </div>
    </form>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3';
const inBrowser = typeof window !== 'undefined';
const emit = defineEmits(['close']);
import { onMounted } from 'vue';

const form = useForm({
    email: '',
    first_name: '',
    last_name: '',
    comment: '',
    phone: '',
    company: '',
    file: '',
    type: 1,
    subject: '',
    express: '',
    errors: {},
});

onMounted(() => {
    // dataLayer.push({ event: 'StartQuoteForm' });
    if (typeof hj !== 'undefined') {
        // hj('event', 'StartQuoteForm');
    }
});

function showWizard(n) {
    if (inBrowser) {
        emit('close');
        window.mitt.emit('open-wizard', true);
    }
}

function submit() {
    let self = this;

    form.post('/job/request', {
        preserveScroll: true,

        onSuccess() {
            emit('close');
            dataLayer.push({ event: 'job_request' });
            if (typeof hj !== 'undefined') {
                hj('event', 'job_request');
            }
        },
    });
}
</script>
